import React from "react";

import { Business } from "../../features";

const BusinessPage = () => {
  return <Business />;
};

export default BusinessPage;
